import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { parseSlashCommandDefinition } from '../../lib/slash-command-definition'

export default function SlashCommandDefinitionPreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()
  const definition = useMemo(() => parseSlashCommandDefinition(event.tags), [event])
  const title = definition.title || definition.command || definition.d

  return (
    <div className={cn('truncate text-sm', className)}>
      {t('Command')}: {title ? `/${definition.command ?? ''} ${title}`.trim() : `#${event.kind}`}
    </div>
  )
}
